import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

export const RejectionList = ({ items, testPrefix = 'rejection' }) => (
  <ul className="space-y-3">
    {items.map((r, i) => {
      const warn = r.status === 'ValidationError';
      return (
        <li key={`${r.sku}-${i}`} data-testid={`${testPrefix}-${r.sku}`} className={`rounded-md border px-3 py-2.5 ${warn ? 'border-[#EBCB8B] bg-[#FBF0DC]' : 'border-[#E9B8B0] bg-[#FBE7E4]'}`}>
          <div className={`text-[13px] font-semibold ${warn ? 'text-[#8a5a12]' : 'text-[#9b2c1f]'}`} data-testid={`${testPrefix}-title-${r.sku}`}>{r.title}</div>
          <div className="text-[12.5px] text-[#5a2a22] whitespace-pre-line mt-1">{r.message}</div>
        </li>
      );
    })}
  </ul>
);

export default function RejectionsDialog({ open, rejections, passCount, onClose, onConfirm, primary }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="rejections-dialog">
      <div className="fm-card w-full max-w-[620px] max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E7E2D3]">
          <div className="flex items-center gap-2 text-[15px] font-semibold"><AlertTriangle size={17} color="#9b2c1f" /> {rejections.length} line(s) cannot be accepted</div>
          <button onClick={onClose} data-testid="rejections-dialog-close" className="text-[#7a6f5c]"><X size={16} /></button>
        </div>
        <div className="px-5 py-4 overflow-y-auto"><RejectionList items={rejections} /></div>
        <div className="flex flex-wrap justify-end gap-2 px-5 py-4 border-t border-[#E7E2D3]">
          <button onClick={onClose} data-testid="rejections-dialog-back" className="px-3 py-2 border border-[#E7E2D3] rounded-md text-[13.5px]">
            {passCount > 0 ? 'Go back' : 'OK'}
          </button>
          {passCount > 0 && (
            <button onClick={onConfirm} data-testid="rejections-dialog-submit" className="px-4 py-2 rounded-md text-white text-[13.5px] font-medium" style={{ background: primary }}>
              Submit {passCount} passing line(s)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
